import * as P from "parsimmon";
import { AndExpression, NotExpression, ObjectAtPositionOperator, ObjectCollisionOperator, ObjectIsAncestorOperator, ObjectStateOperator, OrExpression, } from "./ExpressionNodes";
const whitespace = P.optWhitespace;
const Index = P.index.map(index => index.offset);
const Var = P.regex(/[a-zA-Z_-][a-zA-Z0-9_.-]*/).map((name) => name);
const Op = P.alt(P.string(":"), P.string("@"), P.string("#"), P.string(">"), P.string("<"));
// Var Op Var
const Statement = P.seqMap(Index, Var.skip(whitespace), Op.skip(whitespace), Var.skip(whitespace), Index, (start, left, op, right, end) => {
    switch (op) {
        case ":":
            return new ObjectStateOperator(left, right, start, end);
        case "@":
            return new ObjectAtPositionOperator(left, right, 1e-3, start, end);
        case "#":
            return new ObjectCollisionOperator(left, right, start, end);
        case ">":
            return new ObjectIsAncestorOperator(left, right, start, end);
        case "<":
            return new ObjectIsAncestorOperator(right, left, start, end);
    }
});
// ( Expression )
const BracketedExpression = P.lazy(() => P.string("(")
    .skip(whitespace)
    .then(Condition)
    .skip(P.string(")").skip(whitespace)));
// Statement or ( Expression )
const Expression = P.lazy(() => P.alt(NotExpr, Statement, BracketedExpression));
// !Expression
const NotExpr = P.lazy(() => P.seqMap(Index, P.string("!").trim(whitespace).then(Expression), Index, (start, expr, end) => new NotExpression(expr, start, end)));
// a & b & c
const AndExpr = P.lazy(() => P.sepBy1(Expression, P.string("&").trim(whitespace)).map(terms => terms.reduce((left, right) => new AndExpression(left, right))));
// a & b | c & d | ...
const OrExpr = P.lazy(() => P.sepBy1(AndExpr, P.string("|").trim(whitespace)).map(terms => terms.reduce((left, right) => new OrExpression(left, right))));
const Condition = OrExpr;
export const ConditionParser = Condition.skip(P.eof);
